import FILTERVALUES from "../constants/filterValues";

var TranslationFilterService = (function () {
  const filterTranslation = (translation, playerProgress) => {
    // no translations during opening
    if (playerProgress['seconds'] < 75) {
      translation = "";
    }

    // likely junk if short length
    if (translation.length < 5) {
      translation = "";
    }

    // remove junk at beginning and end of string

    FILTERVALUES["removeCharacter"].forEach((value) => {
      translation = translation.replace(value, "");
    });

    FILTERVALUES["totalClear"].forEach((value) => {
      if (translation === value) {
        translation = "";
      }
    });
    return translation.trim();
  };

  return {
    filterTranslation: filterTranslation,
  };
})();

export default TranslationFilterService;
